import { endOfDay, isAfter } from 'date-fns';

import { taskStatusByCode, FullProject, TaskWithSub } from 'entities';

export function isPast(expectedDate: string): boolean {
  return isAfter(new Date(), endOfDay(new Date(expectedDate)));
}

export function verifyIsExpiredDate(entry: FullProject | TaskWithSub): boolean {
  const isProject = 'tasks' in entry;

  const { expectedDate, status } = entry;

  const expectedCheck = !!expectedDate && isPast(expectedDate);

  if (isProject) return expectedCheck;

  return expectedCheck && taskStatusByCode[status].isActiveStatus;
}

export function verifyHasExpiredDate(entries: FullProject[] | TaskWithSub[]): boolean {
  return entries.some(verifyIsExpiredDate);
}
